import { type FormikProps } from 'formik'

import { useProcurifyIntl } from '@webapp/hooks'
import {
  ExpenseReportForm,
  type ExpenseReportFormSchema,
} from '@webapp/modules/expense/components/ExpenseReportForm'
import { type Expense } from '@webapp/modules/expense/entities/Expense'
import { type ExpenseItem } from '@webapp/modules/expense/entities/ExpenseItem'
import messages from './messages'
import { useEditExpenseReportPresenter } from './useEditExpenseReportPresenter'

export interface IEditExpenseReportPresenterProps {
  expense: Expense
  formRef?: React.MutableRefObject<FormikProps<ExpenseReportFormSchema> | null>
  onSuccess: () => void
  onEditItem: (item: ExpenseItem) => void
  onSubmittingChange?: (isSubmitting: boolean) => void
  onCancel: () => void
}

export const EditExpenseReportPresenter = ({
  expense,
  formRef,
  onSuccess,
  onEditItem,
  onSubmittingChange,
  onCancel,
}: IEditExpenseReportPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    states: { isSubmitting },
    methods: { handleSubmit },
  } = useEditExpenseReportPresenter({ expense, onSuccess, onSubmittingChange })

  return (
    <ExpenseReportForm
      expense={expense}
      onCancel={onCancel}
      canEditLocation={false}
      canEditDepartment={false}
      canEditTravelTicket={true}
      canEditNextApprover={false}
      statusBadges={[
        { type: 'inProgress', text: intl.formatMessage(messages.editingBadge) },
      ]}
      isSubmitting={isSubmitting}
      formRef={formRef}
      onSubmit={handleSubmit}
      onEditItem={onEditItem}
    />
  )
}
